import React, { Component } from "react";
import { authContext } from "./AdalConfig";
import App from "../App";
import { expTokenProcessAndGenerate } from "../Components/ApiSevices/AuthApis";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import LoginPage from "./LoginPage";
import { Token } from "@mui/icons-material";

interface AuthenicationState {
  isLoading: boolean;
  userRoles?: any;
  isAuthenticated: boolean;
  loading: boolean;
  error: any;
}

class Authenication extends Component<{}, AuthenicationState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      isLoading: false,
      userRoles: undefined,
      isAuthenticated: false,
      loading: false,
      error: ''
    };
  }

  async componentDidMount() {
    authContext.handleWindowCallback();
    if (!authContext.isCallback(window.location.hash)) {
      const cachedUser = authContext.getCachedUser();
      await this.GenerateToken();
    }
  }

  GenerateToken = async () => {
    this.setState({ loading: true });
    try {
      await expTokenProcessAndGenerate(sessionStorage.getItem("token"));
      this.updateLoading();
    } catch {
      this.setState({ error: "Login error occurred." });
    } finally {
      this.setState({ loading: false });
    }
  };

    updateLoading = async () => {
      this.setState({ isAuthenticated: false, isLoading: false });
    };

    render() {
      const { isLoading, isAuthenticated } = this.state;
      // if (isLoading) return <p>Loading...</p>;

      const token = sessionStorage.getItem("token");
      const sessionFlag = sessionStorage.getItem("sessionFlag");
      if (!token && window.location.pathname !== "/") {
        window.location.href = "/";
      }

      return token ? (
        <App token={token} isAuthenticated={isAuthenticated} isLoading={isLoading} />
      ) : (
        <LoginPage sessionFlag={sessionFlag} />
      );
    }
  }

export default Authenication;
